import React, { useState } from 'react';
import { Box, Flex, Text, Collapsible } from '@chakra-ui/react';
import { FaChevronDown } from 'react-icons/fa';

const CollapsibleSection = ({
  title,
  children,
  defaultOpen = false,
  headerBg = "blue.600",
  headerColor = "white",
  headerProps = {},
  contentProps = {},
  unmountOnExit = true,
  showArrow = true,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  
  return (
    <Box {...props}>
      <Collapsible.Root 
        open={isOpen} 
        unmountOnExit={unmountOnExit}
      >
        <Collapsible.Trigger asChild>
          <Flex
            align="center"
            justify="space-between"
            bg={headerBg}
            borderRadius="md"
            color={headerColor}
            p={4}
            cursor="pointer"
            _hover={{ opacity: 0.9 }}
            onClick={handleToggle}
            {...headerProps}
          >
            <Text fontWeight="semibold">{title}</Text>
            {showArrow && (
              <Box
                transform={isOpen ? "rotate(180deg)" : "rotate(0deg)"}
                transition="transform 0.2s ease-in-out"
              >
                <FaChevronDown />
              </Box>
            )}
          </Flex>
        </Collapsible.Trigger>

        <Collapsible.Content>
          <Box mt={2} {...contentProps}>
            {children}
          </Box>
        </Collapsible.Content>
      </Collapsible.Root>
    </Box>
  );
};

export default CollapsibleSection;